export type FeedbackAnswer = number | string;

interface QuestionBase {
  id: string;
  prompt: string;
}

export interface FeedbackChoiceOption {
  value: string;
  label: string;
}

export type FeedbackQuestion = QuestionBase &
  (
    | { type: "scale"; min: number; max: number; low: string; high: string }
    | { type: "choice"; options: FeedbackChoiceOption[]; inline?: boolean }
    | { type: "text"; followUp?: boolean }
  );

// Served by the backend; each survey is defined in backend/feedback/surveys/.
export interface FeedbackSurveyDefinition {
  id: string;
  label: string;
  invite: string;
  questions: FeedbackQuestion[];
}

export interface FeedbackSurveyDraft {
  answers: { question: string; value: FeedbackAnswer }[];
  comment: string;
  followUp: boolean;
}

export type FeedbackSendState = "pending" | "sent" | "failed";

export interface FeedbackSurveyResult {
  answers: Record<string, FeedbackAnswer>;
  comment: string;
  followUp: boolean;
  completed: boolean;
}

export const FEEDBACK_ADVANCE_DELAY_MS = 150;

export const FEEDBACK_DRAFT_DELAY_MS = 500;

export const FEEDBACK_SHOW_DELAY_MS = 30_000;

export const FEEDBACK_COMMENT_MAX_LENGTH = 5000;

export const FEEDBACK_CLOSE_DELAY_MS = 4000;

// The leave timings differ per property, which needs the arbitrary [transition:…].
export const FEEDBACK_TRANSITION = {
  appear: true,
  enterActiveClass:
    "transition-[translate,scale,opacity] duration-500 ease-[cubic-bezier(0.34,1.56,0.64,1)] motion-reduce:transition-none",
  enterFromClass: "translate-y-4 scale-95 opacity-0",
  leaveActiveClass:
    "[transition:scale_320ms_cubic-bezier(0.36,0,0.66,-0.56),opacity_240ms_cubic-bezier(0.4,0,1,1)_80ms,filter_240ms_cubic-bezier(0.4,0,1,1)_80ms] motion-reduce:transition-none",
  leaveToClass: "scale-90 opacity-0 blur-xs",
};
